/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Method_4Inputs */

const en_fw_bm_method_4 = /** @type {(inputs: Fw_Bm_Method_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomputed hourly. Agent names are self-reported by the CLI, so "unreported" means the run did not name one.`)
};

const id_fw_bm_method_4 = /** @type {(inputs: Fw_Bm_Method_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dihitung ulang tiap jam. Nama agen dilaporkan sendiri oleh CLI, jadi "tak dilaporkan" berarti proses itu tidak menyebut namanya.`)
};

/**
* | output |
* | --- |
* | "Recomputed hourly. Agent names are self-reported by the CLI, so \"unreported\" means the run did not name one." |
*
* @param {Fw_Bm_Method_4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_method_4 = /** @type {((inputs?: Fw_Bm_Method_4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Method_4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_method_4(inputs)
	return en_fw_bm_method_4(inputs)
});